import { Component, OnInit, input } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';
import { FlexComponent } from '../flex-component/flex.component';

@RegisterComponent('FlexCard')
@Component({
  selector: 'app-flex-card',
  standalone: true,
  imports: [],
  templateUrl: './flex-card.component.html',
  styleUrl: './flex-card.component.scss'
})
export class FlexCardComponent extends FlexComponent implements OnInit {

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
